import { chargePointActions } from './reducers';

export const {
  getCurrentChargePointAction,
  setCurrentChargePointAction,
  setChargePointErrorAction,
  clearCurrentChargePointAction,
} = chargePointActions;
